var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('avp-breadcrumbs'), _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Pesquisar Motivo",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "descricao", $$v);
      },
      expression: "form.filters.descricao"
    }
  })], 1), _c('avp-select-ativo', {
    attrs: {
      "cols": 2
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('avp-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarMotivo();
      }
    }
  }), _c('avp-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('avp-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterMotivo();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listMotivos,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.motivo`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.descricao) + " ")];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('avp-label-ativo', {
          attrs: {
            "ativo": item.ativo
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('avp-tooltip', {
          attrs: {
            "text": 'Editar Motivo',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterMotivo(item);
            }
          }
        }), _c('avp-tooltip', {
          attrs: {
            "text": 'Visualizar Motivo',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarMotivo(item);
            }
          }
        }), _c('avp-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar' : 'Ativar'} Motivo`,
            "icon": `${item.ativo ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarMotivo(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarMotivoDialog', {
    attrs: {
      "visible": _vm.dialogManterMotivo.visible,
      "content": _vm.dialogManterMotivo.content,
      "edit": _vm.dialogManterMotivo.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterMotivo.close();
      },
      "onSave": function ($event) {
        return _vm.buscarMotivo();
      }
    }
  }), _c('VisualizarMotivoDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarMotivo.visible,
      "content": _vm.dialogVisualizarMotivo.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarMotivo.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }